module.exports = __webpack_public_path__ + "static/sf-home-page-34ba27b3abeb6113e474e96ebe27ee81.png";